<template>
  <Card
    subTitleTag="span"
    style="
      margin: 0 2rem;
      border: 0 !important;
      border-radius: 8px;
      -webkit-box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.1);
      box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.1);
    "
  >
    <template #title>
      <div v-if="!renamingAnalysis">
        {{ thisAnalysisNameRenamed }}
      </div>

      <div v-if="renamingAnalysis == true" @click.stop.prevent="">
        <input
          name="slide-name"
          type="text"
          style="width: 40rem; max-width: 80%"
          v-model="thisAnalysisNameRenamed"
          @change="saveAnalysisTitle"
        />
        <button
          @click="renamingAnalysis = !renamingAnalysis"
          style="background-color: transparent; border: none"
        >
          <SvgIconMeaningful icon="check" title="save title" />
        </button>
      </div>

      <span class="project-status" v-if="projectStatus">({{ projectStatus }})</span>

      <div
        style="
          margin-top: 1rem;
          display: flex;
          flex-direction: row;
          width: 100%;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          v-if="project.benchmarkAnalysis && project.benchmarkAnalysis > 0"
          style="margin-left: 1rem"
        >
          <img
            style="width: 1.25rem; opacity: 0.75"
            src="/assets/benchmarking_chart.png"
            alt="has benchmarking analysis"
            title="has benchmarking analysis"
          />
        </div>
        <div
          v-if="project.textAnalysisObjects && project.textAnalysisObjects > 0"
          style="margin-left: 1rem"
        >
          <img
            style="width: 1.35rem; opacity: 0.75"
            src="/assets/sentiment_chart.png"
            alt="has text analysis"
            title="has text analysis"
          />
        </div>
        <div
          v-if="project.performanceAnalysis && project.performanceAnalysis > 0"
          style="margin-left: 1rem"
        >
          <img
            style="width: 1.25rem; opacity: 0.75"
            src="/assets/performance_chart.png"
            alt="has bar charts"
            title="has bar charts"
          />
        </div>
        <div
          v-if="project.outliersAnalysis && project.outliersAnalysis > 0"
          style="margin-left: 1rem"
        >
          <img
            style="width: 1.25rem; opacity: 0.75"
            src="/assets/outliers_analysis.png"
            alt="has outliers analysis"
            title="has outliers analysis"
          />
        </div>
        <div
          v-if="project.driversAnalysis && project.driversAnalysis > 0"
          style="margin-left: 1rem"
        >
          <img
            style="width: 1.25rem; opacity: 0.75"
            src="/assets/matrix_chart.png"
            alt="has drivers/regression analysis"
            title="has drivers/regression analysis"
          />
        </div>
      </div>
    </template>
    <template #subtitle>
      {{ formatDate(project.last_modified_on.$date, setLanguage) }}
    </template>

    <div class="card__text-content">
      <ProjectsItemNav
        :project="project"
        :setToEdit="setToEdit"
        :setToReport="setToReport"
        :setToShare="setToShare"
      />
      <ProjectsItemDatasetDeleted v-if="!datasetNotDeleted" />
    </div>
  </Card>
</template>

<script>
// Components
import Card from '@/components/UI/Card.vue';
import ProjectsItemDatasetDeleted from './ProjectsItemDatasetDeleted.vue';
import ProjectsItemNav from './ProjectsItemNav.vue';
import SvgIconMeaningful from '@/components/UI/Svg/SvgIconMeaningful.vue';

// Models
import BenchmarkingProject from '@/models/BenchmarkingProjectModel.js';

import moment from 'moment';

export default {
  name: 'ProjectsGrid',
  components: {
    Card,
    ProjectsItemDatasetDeleted,
    ProjectsItemNav,
    SvgIconMeaningful,
  },
  props: {
    project: {
      default: () => {},
      type: BenchmarkingProject,
    },
    datasetProjects: {
      default: () => [],
      type: Array,
    },
    setToEdit: {
      default: () => false,
      type: Boolean,
    },
    setToReport: {
      default: () => false,
      type: Boolean,
    },
    setToShare: {
      default: () => false,
      type: Boolean,
    },
    setToRename: {
      default: () => false,
      type: Boolean,
    },
  },
  data() {
    return {
      renamingAnalysis: false,
      thisAnalysisNameRenamed: '',
    };
  },
  created() {
    if (this.project.name) {
      this.thisAnalysisNameRenamed = this.project.name;
    }
  },
  computed: {
    datasetNotDeleted() {
      const datasetIds = this.datasetProjects.map((dataset) => dataset.dataset_id);
      return this.project.datasets.every((dataset) => datasetIds.includes(dataset));
    },
    projectStatus() {
      const id = this.$store.getters['user/getProfile'].django_ref_id;
      const email = this.$pigeonline.getUserEmail();

      const access = this.project.access_type;
      if (access && access == 'public__all') return 'public';
      if (access && access == 'public__team') return 'team';

      const shared =
        this.project.shared &&
        Array.isArray(this.project.shared) &&
        this.project.shared.map((r) => this.bkCompatiblePk(r));
      if (shared && (shared.includes(id) || shared.includes(email))) {
        return 'shared';
      }

      return null;
    },
    setLanguage() {
      return this.$store.getters.getLanguage;
    },
  },
  methods: {
    bkCompatiblePk(r) {
      return ['string', 'number'].includes(typeof r)
        ? r
        : typeof r.pk !== 'undefined'
          ? r.pk
          : typeof r.id !== 'undefined'
            ? r.id
            : -1;
    },
    formatDate: (value, language) => {
      let currentLang = '';
      if (language) {
        currentLang = language;
      }
      if (value) {
        if (currentLang === 'fr') {
          return moment(value).locale('fr').format('MMMM D, YYYY');
        } else {
          return moment(value).format('MMMM D, YYYY');
        }
      }
    },
    async saveAnalysisTitle() {
      let response = await this.$pigeonline.projects.getByID(BenchmarkingProject, this.project.id);
      if (response) {
        response.name = this.thisAnalysisNameRenamed;
        await this.$pigeonline.projects.update(response);
      }
      this.toggleRename();
    },
    toggleRename() {
      this.renamingAnalysis = !this.renamingAnalysis;
    },
  },
  watch: {
    setToRename: async function (val) {
      if (val) {
        this.toggleRename();
      }
    },
  },
};
</script>
